import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiKeysDto } from "cilor-db-api-shared";

@Injectable({
  providedIn: "root"
})
export class ApikeysService {

  public loading: boolean;
  public apiKeys: ApiKeysDto | null;
  public error: string | null;

  constructor(
    private httpClient: HttpClient
  ) {
    this.loading = true;
    this.apiKeys = null;
  }

  public loadApiKeys(): void {
    this.loading = true;
    this.httpClient.get<ApiKeysDto>("/api/status/apikeys").toPromise()
      .then((result) => {
        this.apiKeys = result;
      })
      .catch((error: Error) => {
        this.error = error.message;
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
